<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book was inspired by my daughters Joanne Barbera and Laura Kusic and my five grandchildren Dr. Nicolas Barbera, Jenna Barbera, Matthew Barbera, Gabrielle Barbera and Juliana Kusic. I dedicate this book to the love of my life, my wife of 60 years Beverly Ann Scrudato.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?74ef78ce